import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useChatStore } from '../../stores/chatStore';

export default function ChatBadge() {
  const totalUnread = useChatStore((s) => s.totalUnread);
  const fetchTotalUnread = useChatStore((s) => s.fetchTotalUnread);

  useEffect(() => {
    fetchTotalUnread();
    const interval = setInterval(fetchTotalUnread, 60000);
    return () => clearInterval(interval);
  }, [fetchTotalUnread]);

  return (
    <Link
      to="/chat"
      className="relative rounded-lg p-2 text-gray-600 transition-colors hover:bg-gray-100"
      aria-label="채팅"
    >
      <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
        />
      </svg>
      {totalUnread > 0 && (
        <span className="absolute -right-0.5 -top-0.5 flex h-4 min-w-[16px] items-center justify-center rounded-full bg-red-500 px-1 text-[10px] font-bold text-white">
          {totalUnread > 99 ? '99+' : totalUnread}
        </span>
      )}
    </Link>
  );
}
